// extracted by mini-css-extract-plugin
module.exports = {"btn":"remove-button__btn___3pZZt","light":"remove-button__light___10Xdo","dark":"remove-button__dark___6i4UT"};